import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "../lib/api";
import { Reveal } from "./Reveal";

export const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/newsletter", { email });
      setDone(true);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="bg-cocoa text-cream" data-testid="newsletter-section">
      <div className="mx-auto max-w-7xl px-6 py-20 text-center md:px-10 md:py-28">
        <Reveal>
          <p className="text-[11px] uppercase tracking-[0.35em] text-gold">Newsletter</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-4 font-serif text-4xl font-light md:text-5xl">Join Our Journey</h2>
        </Reveal>
        <Reveal delay={0.18}>
          <p className="mx-auto mt-4 max-w-md text-sm font-light leading-relaxed text-cream/70">
            Be the first to know about new launches, exclusive offers and more.
          </p>
        </Reveal>
        <Reveal delay={0.26}>
          {done ? (
            <p className="mt-10 font-serif text-2xl italic text-gold" data-testid="newsletter-success">
              Thank you — welcome to Zelvoria.
            </p>
          ) : (
            <form
              onSubmit={submit}
              data-testid="newsletter-form"
              className="mx-auto mt-10 flex max-w-md items-stretch border border-cream/25 transition-colors focus-within:border-gold"
            >
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email address"
                data-testid="newsletter-email-input"
                className="w-full bg-transparent px-5 py-4 text-sm font-light outline-none placeholder:text-cream/40"
              />
              <button
                type="submit"
                disabled={loading}
                data-testid="newsletter-submit-button"
                className="flex shrink-0 items-center gap-2 bg-gold px-6 text-[10px] uppercase tracking-[0.25em] text-ivory transition-colors duration-500 hover:bg-gold-light disabled:opacity-60"
              >
                Subscribe <ArrowRight size={13} />
              </button>
            </form>
          )}
        </Reveal>
      </div>
    </section>
  );
};
